__webpack_require__.p = "//cdn.osyb.cn/gh/Zhang-Tian-Cheng/voteDist@main/v1.0.4/";